module.exports = __webpack_public_path__ + "img/resultItem.df6f3509.jpg";